import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { activateEditMode, loadSubscription, unsubscribeJobseeker } from '../../root-store/jobseeker-store/jobseeker-subscription/actions';
import { AppState } from '../../root-store/state';
import { JobseekerLocationViewModel, JobseekerSeniorityLevelViewModel, JobseekerSpecializationViewModel } from '../shared/services/jobseeker.service';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { selectSubscriptionLocations, selectSubscriptionSeniorityLevels, selectSubscriptionSpecializations } from '../../root-store/jobseeker-store/jobseeker-subscription/selectors';

@Component({
    selector: 'app-view-subscription',
    templateUrl: './redesign/view-jobseeker-subscription.component.html',
    styleUrls: ['./redesign/view-jobseeker-subscription.component.scss'],
    standalone: false
})
export class ViewJobseekerSubscriptionComponent implements OnInit {

  public subscriptionSpecializations$: Observable<JobseekerSpecializationViewModel[]>;
  public subscriptionLocations$: Observable<JobseekerLocationViewModel[]>;
  public subscribedSeniorityLevels$: Observable<JobseekerSeniorityLevelViewModel[]>;

  public dialogService = inject(DialogService);


  onEdit(){
    this.store.dispatch(activateEditMode());
    this.router.navigate(['/jobseeker/subscription/edit']);
  }

  onUnsubscribe(){
    this.dialogService
          .openConfirmDialog('message.AreYouSure')
          .afterClosed()
          .subscribe((res) => {
            if (res) {
              this.store.dispatch(unsubscribeJobseeker())
            }
    });
  }

  constructor(private route: ActivatedRoute, private router: Router, private store: Store<AppState>) { }

  ngOnInit(): void {
    this.store.dispatch(loadSubscription());
    this.subscriptionSpecializations$ = this.store.pipe(select(selectSubscriptionSpecializations));
    this.subscriptionLocations$ = this.store.pipe(select(selectSubscriptionLocations));
    this.subscribedSeniorityLevels$ = this.store.pipe(select(selectSubscriptionSeniorityLevels));
  }
}